import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  InternalOpsPage,
  InternalOpsState,
  PageControls,
  SortableTable,
  TABLE_PAGE_SIZE,
  rowsForPage,
  formatCount,
  formatWhen,
  useApiFilters,
  useDayRange,
  usageQuery,
  useInternalOpsFetch,
  withQuery,
} from "./internalOpsUi";
import { API_ENDPOINTS } from "../../config/apiConfig";

export default function InternalOpsParcelPopularity() {
  const { appLabel } = useParams();
  const [page, setPage] = useState(1);
  const [days] = useDayRange();
  const filters = useApiFilters();
  const { data, loading, error } = useInternalOpsFetch(
    withQuery(API_ENDPOINTS.internalOpsParcelPopularity, { page, page_size: TABLE_PAGE_SIZE })
  );

  return (
    <InternalOpsPage
      title="Parcel popularity"
      subtitle="How often Charger Plan parcels are added to a comparison table or inspected, across every account."
    >
      <p className="mb-4 text-sm text-slate-600">
        <Link to={withQuery("/internal/api-usage", usageQuery(days, filters))} className="font-medium text-blue-700 hover:underline">
          All applications
        </Link>
        <span className="px-2 text-slate-300">/</span>
        <Link
          to={withQuery(`/internal/api-usage/${encodeURIComponent(appLabel)}`, usageQuery(days, filters))}
          className="font-medium text-blue-700 hover:underline"
        >
          Charger Plan
        </Link>
      </p>
      <InternalOpsState loading={loading} error={error}>
        {data ? (
          <div className="min-w-0 space-y-3">
          <PageControls
            page={data.page || page}
            pageCount={data.page_count}
            count={data.count}
            pageSize={data.page_size || TABLE_PAGE_SIZE}
            onPage={setPage}
          />
          <SortableTable
            paginate={false}
            rows={rowsForPage(data.results, data.page || page, data.page_size || TABLE_PAGE_SIZE)}
            empty="No parcel activity recorded yet."
            rowKey={(row) => row.parcel_id}
            columns={[
              {
                key: "address",
                label: "Address",
                sortValue: (row) => row.address || `Parcel ${row.parcel_id}`,
                render: (row) => row.address || `Parcel ${row.parcel_id}`,
              },
              { key: "apn", label: "APN", sortValue: (row) => row.apn || "", render: (row) => row.apn || "—" },
              { key: "zip", label: "ZIP", sortValue: (row) => row.zip || "", render: (row) => row.zip || "—" },
              {
                key: "added_to_table_count",
                label: "Added to table",
                sortValue: (row) => row.added_to_table_count,
                render: (row) => formatCount(row.added_to_table_count),
              },
              {
                key: "inspected_count",
                label: "Inspected",
                sortValue: (row) => row.inspected_count,
                render: (row) => formatCount(row.inspected_count),
              },
              {
                key: "account_count",
                label: "Accounts",
                sortValue: (row) => row.account_count,
                render: (row) => formatCount(row.account_count),
              },
              {
                key: "last_event_at",
                label: "Last activity",
                cellClassName: "text-slate-500",
                sortValue: (row) => row.last_event_at,
                render: (row) => formatWhen(row.last_event_at),
              },
            ]}
          />
          </div>
        ) : null}
      </InternalOpsState>
    </InternalOpsPage>
  );
}
